






































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { dateTypes, TypeFilterDate } from '../models';
import {
    FilterDateEvent,
    getDateByFormat,
    Method,
    hasElements,
    EventBus,
    TypeEventBus,
    getDateTimeToYesterday,
    getDateTimeFromYesterday,
    getDateTimeToToDay,
    getDateTimeFromToDay,
    PRIVILEGE_KEYS,
    PRIVILEGE_TYPES
} from '../utils';
import DateRangeSelector from './DateRangeSelector.vue';
import FilterButton from './FilterButton.vue';
import { RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
@Component({
    components: { FilterButton, DateRangeSelector }
})
export default class FilterDate extends Mixins(RootStoreHelper, AuthStoreHelper) {
    @Prop({ default: TypeFilterDate.RANGE_DATE }) currentSelected: number;
    @Prop() currentRangeSelected: Date[];
    @Prop({ default: () => () => console.log('[FilterDate] Change filter') }) changeFilter: Method<
        FilterDateEvent,
        void
    >;
    showDateRange: boolean = false;
    openRangeDate: boolean = false;
    @Prop({ default: false }) disableButtons: boolean;
    @Prop({ default: false }) isMock: boolean;
    showDate: boolean = true;

    getGAClasses(button) {
        if (!this.$store.state.userGroupSmartway) {
            switch (button) {
                case 1:
                    return 'ga_btn_filters_fecha';
                case 2:
                    return 'ga_btn_filters_ayer';
                case 3:
                    return 'ga_btn_filters_hoy';
                case 4:
                    return 'ga_btn_filters_ahora';
            }
        } else {
            return '';
        }
    }

    handleFilter(selected, range) {
        this.$_setTypeFilterDate(TypeFilterDate.RANGE_DATE);
        // if (hasElements(filter.range)) {
        this.changeFilter({
            typeFilterDate: selected,
            range: range
        });
        this.$_setDateRange(range);
        EventBus.$emit(TypeEventBus.CLOSE_DATEPICKER_POPUP);
        // } else {
        //     this.$_setDateRange({
        //         datetime_to: '',
        //         datetime_from: ''
        //     });
        // }
    }

    get shouldDisplayDateRange() {
        if (this.isFilterActive(this.getRangeDate())) {
            return true;
        } else {
            return false;
        }
    }

    get dateFilterButton() {
        return this.$refs.dateFilterButton;
    }

    isFilterActive(filter: number): boolean {
        return this.currentSelected === filter;
    }

    getToday(): number {
        return TypeFilterDate.TODAY;
    }

    getYesterday(): number {
        return TypeFilterDate.YESTERDAY;
    }

    getRangeDate(): number {
        return TypeFilterDate.RANGE_DATE;
    }

    getTr(): number {
        return TypeFilterDate.TR;
    }
    showRangeDate() {
        this.openRangeDate = true;
    }

    hideRangeDate() {
        this.openRangeDate = false;
    }

    layoutStyle = {
        maxWidth: '440px'
    };

    @Watch('currentSelected')
    observableCurrentSelected(value: number) {
        if (value !== TypeFilterDate.RANGE_DATE) {
            this.hideRangeDate();
            this.layoutStyle.maxWidth = '440px';
        } else {
            this.showRangeDate();
            this.layoutStyle.maxWidth = '80%';
        }
    }

    updateFilterDate(filter) {
        if (hasElements(this.currentRangeSelected)) {
            this.changeFilter({
                typeFilterDate: filter.typeFilterDate,
                range: filter.range
            });
        } else {
            this.changeFilter({
                typeFilterDate: 2,
                range: {
                    datetime_to: '',
                    datetime_from: ''
                }
            });
        }
    }

    handleChangeFilter(selected: number) {
        if (!this.isMock) {
            // if (selected === TypeFilterDate.TODAY) {
            //     this.changeFilter({
            //         typeFilterDate: selected,
            //         range: null
            //         // range: {
            //         //     datetime_to: getDateTimeToToDay(),
            //         //     datetime_from: getDateTimeFromToDay()
            //         // }
            //     });
            // } else if (selected === TypeFilterDate.YESTERDAY) {
            //     this.changeFilter({
            //         typeFilterDate: selected,
            //         range: null
            //         // range: {
            //         //     datetime_to: getDateTimeToYesterday(),
            //         //     datetime_from: getDateTimeFromYesterday()
            //         // }
            //     });
            // } else
            if (selected === TypeFilterDate.RANGE_DATE) {
                if (hasElements(this.currentRangeSelected)) {
                    this.changeFilter({
                        typeFilterDate: selected,
                        range: {
                            datetime_to: getDateByFormat(
                                dateTypes.globalFilterDateFormat,
                                this.currentRangeSelected[1]
                            ).toString(),
                            datetime_from: getDateByFormat(
                                dateTypes.globalFilterDateFormat,
                                this.currentRangeSelected[0]
                            ).toString()
                        }
                    });
                } else {
                    this.getDateRangeRef.resetFilter();
                    this.changeFilter({
                        typeFilterDate: selected,
                        range: {
                            datetime_from: '',
                            datetime_to: ''
                        }
                    });
                }
            } else {
                this.getDateRangeRef.resetFilter();
                this.changeFilter({
                    typeFilterDate: selected,
                    range: null
                    // range: {
                    //     datetime_to: getDateTimeToYesterday(),
                    //     datetime_from: getDateTimeFromYesterday()
                    // }
                });
            }

            // if (selected == TypeFilterDate.TR) {
            //     this.changeFilter({
            //         typeFilterDate: selected,
            //         range: null
            //     });
            // } else {
            //     this.changeFilter({
            //         typeFilterDate: selected,
            //         range: null
            //         // range: {
            //         //     datetime_to: '',
            //         //     datetime_from: ''
            //         // }
            //     });
            // }
        }
    }

    get getDateRangeRef() {
        return this.$refs.dateRange as any;
    }

    mounted() {}
}
